<template>
  <div class="lh-copy pl3 pb3 pl6-ns pb6-ns poppins-regular brown f3-ns f5 mw6-ns mw5 flex items-end vh-100">
    <span>
      A <span class="poppins-medium">creative studio</span> focused on collaborations.
      Creating good<a href="#design" class="link dim"> design, styling, art direction </a>
      &amp; photography or providing brand solutions.
    </span>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
